import React, { Component } from "react";
import { Divider, Row, Layout, Button } from "antd";
import { Link } from "react-router-dom";
import ReactGA from "react-ga4";
import throttle from "lodash.throttle";
import PropTypes from "prop-types";
import BestCatsTable from "../../table/BestCatsTable";
import TierListTable from "../../table/TierListTable";
import {
  FacebookShareButton,
  RedditShareButton,
  TwitterShareButton,
  VKShareButton,
  FacebookIcon,
  RedditIcon,
  TwitterIcon,
  VKIcon,
} from "react-share";
import VenatusAd from "../../ads/VenatusAd";
import VenatusAdWithPlaceholder from "../../ads/VenatusAdWithPlaceholder";
import {
  VENATUS_DESKTOP_LEADERBOARD,
  VENATUS_MOBILE_INCONTENT,
  VENATUS_RICH_MEDIA_WITH_STICKY_VERTICAL,
  VENATUS_RICH_MEDIA,
} from "../../utilities/constants";

const shareURL = "https://mygamatoto.com/ultra-souls-tier-list";
const { Content } = Layout;

export const initGA = () => {
  ReactGA.initialize(
    "G-MX6GYDK28N"
    // , {
    //   gaAddress: "https://onestoppress.com/analytics.js"
    // }
  );
};

export const logPageView = () => {
  ReactGA.set({ page: window.location.pathname + window.location.search });
};

class Almighties extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewportWidth: 0,
      compareCatsLevels: 30,
    };
  }
  componentDidMount() {
    this.saveViewportDimensions();
    window.addEventListener("resize", this.saveViewportDimensions);

    // initGA();
    // logPageView();

    document.title = "Almighties Tier List | Battle Cats Wiki for Cat Stats";
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.saveViewportDimensions);
  }

  saveViewportDimensions = throttle(() => {
    let adjustViewport;
    if (window.innerWidth < 636) {
      adjustViewport = 22;
    } else if (window.innerWidth < 948) {
      adjustViewport = 34;
    } else {
      adjustViewport = 46;
    }

    this.setState({
      viewportWidth: window.innerWidth - adjustViewport,
    });
  }, this.props.applyViewportChange);

  showModal = () => {
    this.setState({ isModalVisible: true });
  };

  handleCancel = () => {
    this.setState({ isModalVisible: false });
  };

  render() {
    const bestCats = [
      {
        key: "260-1",
        name: "Radiant Aphrodite",
        number: "260-1",
        form: "Normal",
        rarity: "Uber Super Rare",
        level: 1,
        health: 4875,
        damage: 4500,
        range: 600,
        kb: 4,
        speed: 7,
        dps: 375,
        target: "Area",
        tba: "11.97",
        anim: "4.07",
        spawn: "131.20",
        cost: 4500,
        ability:
          "u1Against alienu2: b1Massive Damageb2 (inflicts 3.0x damage) \r\nu1General Abilitiesu2: b1Long Distanceb2 (Effective range 450~850)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "440-1",
        name: "Empress Chronos",
        number: "440-1",
        form: "Normal",
        rarity: "Uber Super Rare",
        level: 1,
        health: 5000,
        damage: 4000,
        range: 450,
        kb: 3,
        speed: 8,
        dps: 388,
        target: "Area",
        tba: "10.30",
        anim: "0.67",
        spawn: "124.53",
        cost: 4050,
        ability:
          "u1Against red, black, floating, metal, angel, alien, zombie, relic, akuu2: b1Freezeb2 (100% chance to freeze for 1.0s) \r\nu1General Abilitiesu2: b1Long Distanceb2 (Effective range 300~700) b1Multi-hit attackb2 (Attacks thrice consecutively)\r\nu1Not affected byu2: b1Freezeb2",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "494-1",
        name: "Gaia the Creator",
        number: "494-1",
        form: "Normal",
        rarity: "Legendary Rare",
        level: 1,
        health: 10000,
        damage: 6975,
        range: 400,
        kb: 2,
        speed: 8,
        dps: 698,
        target: "Area",
        tba: "10.00",
        anim: "4.57",
        spawn: "123.20",
        cost: 4470,
        ability:
          "u1Against red, black, floating, metal, angel, alien, zombie, relic, akuu2: b1Insane Damageb2 (inflicts 5.0x damage) \r\nu1General Abilitiesu2: b1Long Distanceb2 (Effective range 350~550) b1Multi-hit attackb2 (Attacks thrice consecutively)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "272-1",
        name: "Shining Amaterasu",
        number: "272-1",
        form: "Normal",
        rarity: "Uber Super Rare",
        level: 1,
        health: 5450,
        damage: 1875,
        range: 455,
        kb: 4,
        speed: 10,
        dps: 282,
        target: "Area",
        tba: "6.63",
        anim: "2.00",
        spawn: "124.53",
        cost: 4740,
        ability:
          "u1Against red, black, floating, metal, angel, alien, zombie, relic, akuu2: b1Massive Damageb2 (inflicts 3.0x damage)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "273-1",
        name: "Splendid Ganesha",
        number: "273-1",
        form: "Normal",
        rarity: "Uber Super Rare",
        level: 1,
        health: 6450,
        damage: 3700,
        range: 400,
        kb: 5,
        speed: 9,
        dps: 398,
        target: "Area",
        tba: "9.30",
        anim: "2.67",
        spawn: "114.53",
        cost: 4350,
        ability:
          "u1General Abilitiesu2: b1Strengthenb2 (attack power increases by 50% at 80% health) b1Long Distanceb2 (Effective range 275~725)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "317-1",
        name: "Wrathful Poseidon",
        number: "317-1",
        form: "Normal",
        rarity: "Uber Super Rare",
        level: 1,
        health: 5625,
        damage: 4625,
        range: 350,
        kb: 5,
        speed: 30,
        dps: 628,
        target: "Area",
        tba: "7.37",
        anim: "1.77",
        spawn: "84.53",
        cost: 3900,
        ability:
          "u1Against metal, zombieu2: b1Freezeb2 (100% chance to freeze for 3.33s) \nu1General Abilitiesu2: b1Zombie Killerb2 (Stops zombies from reviving)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "258-1",
        name: "Thunder God Zeus",
        number: "258-1",
        form: "Normal",
        rarity: "Uber Super Rare",
        level: 1,
        health: 7875,
        damage: 3625,
        range: 480,
        kb: 2,
        speed: 8,
        dps: 608,
        target: "Area",
        tba: "5.97",
        anim: "2.13",
        spawn: "157.87",
        cost: 4800,
        ability: "u1Against angelu2: b1Resistantb2 (only takes 0.25x damage)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "535-1",
        name: "Hades the Punisher",
        number: "535-1",
        form: "Normal",
        rarity: "Uber Super Rare",
        level: 1,
        health: 47500,
        damage: 1575,
        range: 250,
        kb: 2,
        speed: 8,
        dps: 775,
        target: "Area",
        tba: "2.03",
        anim: "1.50",
        spawn: "131.20",
        cost: 4425,
        ability:
          "u1General Abilitiesu2: b1Multi-hit attackb2 (Attacks thrice consecutively)\nu1Not affected byu2: b1Warpb2, b1Toxicb2",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "259-1",
        name: "Anubis the Protector",
        number: "259-1",
        form: "Normal",
        rarity: "Uber Super Rare",
        level: 1,
        health: 6000,
        damage: 5250,
        range: 425,
        kb: 3,
        speed: 18,
        dps: 590,
        target: "Area",
        tba: "8.90",
        anim: "3.87",
        spawn: "137.87",
        cost: 4200,
        ability:
          "u1General Abilitiesu2: b1Zombie Killerb2 (Stops zombies from reviving)\nu1Not affected byu2: b1Slowb2, b1Waveb2",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
    ];

    const tierList = [
      {
        tier: "SS",
        cats: [],
      },
      {
        tier: "S",
        cats: [
          { name: "Radiant Aphrodite", number: "260-1" },
          { name: "Empress Chronos", number: "440-1" },
        ],
      },
      {
        tier: "A+",
        cats: [
          { name: "Gaia the Creator", number: "494-1" },
          { name: "Shining Amaterasu", number: "272-1" },
          { name: "Splendid Ganesha", number: "273-1" },
        ],
      },
      {
        tier: "A",
        cats: [],
      },
      {
        tier: "B+",
        cats: [{ name: "Wrathful Poseidon", number: "317-1" }],
      },
      {
        tier: "B",
        cats: [{ name: "Thunder God Zeus", number: "258-1" }],
      },
      {
        tier: "B-",
        cats: [],
      },
      {
        tier: "C+",
        cats: [
          { name: "Hades the Punisher", number: "535-1" },
          { name: "Anubis the Protector", number: "259-1" },
        ],
      },
      {
        tier: "C",
        cats: [],
      },
      {
        tier: "D",
        cats: [],
      },
    ];

    return (
      <div>
        <div className="pagetitle">
          <h1 style={{ padding: "10px 0 0 0", marginBottom: "6px" }}>
            Tier List
          </h1>
          <Divider style={{ margin: "0 0 0 0", padding: "0 0 0 0" }} />
        </div>
        <Layout style={{ padding: "0 12px 0 12px", background: "white" }}>
          <Content className="flexible-width">
            <Row style={{ padding: "16px 0 0 0" }}>
              <div>
                {this.state.viewportWidth > 1024 ? (
                  <span>
                    <VenatusAdWithPlaceholder
                      placementId={VENATUS_DESKTOP_LEADERBOARD}
                    />
                  </span>
                ) : (
                  ""
                )}
                <h2 style={{ marginTop: "12px", fontSize: "24px" }}>
                  The Almighties Tier List
                </h2>
                <p></p>
                <div>
                  Tier list for The Almighties, listed from worst to best.
                  Credit goes to the Tier List on the{" "}
                  <a href="https://www.reddit.com/r/battlecats/wiki/index">
                    Reddit r/battlecats Wiki
                  </a>
                  &nbsp;under the Cat Guides.
                  <p></p>
                  <i>Last updated: 27 November 2021</i>
                </div>
              </div>
            </Row>

            <Row style={{ margin: "16px 0 0 0" }}>
              <FacebookShareButton
                url={"http://mygamatoto.com" + window.location.pathname}
                style={{ marginRight: "0.25rem" }}
              >
                <FacebookIcon size={32} round />
              </FacebookShareButton>
              <TwitterShareButton
                url={"http://mygamatoto.com" + window.location.pathname}
                title="MyGamatoto - The Almighties Tier List"
                style={{ marginRight: "0.25rem" }}
              >
                <TwitterIcon size={32} round />
              </TwitterShareButton>
              <RedditShareButton
                url={"http://mygamatoto.com" + window.location.pathname}
                style={{ marginRight: "0.25rem" }}
              >
                <RedditIcon size={32} round />
              </RedditShareButton>
              <VKShareButton
                url={"http://mygamatoto.com" + window.location.pathname}
                title="MyGamatoto - The Almighties Tier List"
                style={{ marginRight: "0.25rem" }}
              >
                <VKIcon size={32} round />
              </VKShareButton>
            </Row>
            {this.state.viewportWidth > 1024 ? (
              ""
            ) : (
              <div style={{ margin: "10px 0 0 0" }}>
                <div
                  class="vm-placement"
                  id="vm-av"
                  data-format="isvideo"
                ></div>
              </div>
            )}
            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  9.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[8].number +
                      ".png"
                    }
                    alt={bestCats[8].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[8].number.slice(0, 3) +
                          "/" +
                          bestCats[8].name
                        }
                      >
                        {bestCats[8].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>God of Death who escorts human souls to
                  the underworld. His Nether Staff purges mortals of sin.
                  Unharmed by wave attacks. (Area Attack)
                  <p></p>
                  <b>Other forms: </b>Anubis the Unblemished, Almighty Anubis
                  <p></p>
                  <b>Pros: </b>Highest health out of the bunch, but not by much.
                  <p></p>
                  <b>Cons: </b>Long attack animation, long range, and decent
                  speed means he tends to miss pretty often. Just like{" "}
                  <Link to={"/catinfo/136/Super%20Galaxy%20Cosmo"}>
                    Super Galaxy Cosmo
                  </Link>
                  , this means he tends to rush in like a suicide bomber and
                  then miss. He's still a good doggo, though.
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Anubis the Protector"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            {/* <InPageAdComponent
              style={{ marginTop: "8px" }}
              dataAdClient="ca-pub-1920730948516638"
              dataAdSlot="8579060881"
            /> */}
            {/* <div id="waldo-tag-14680"></div> */}
            <div style={{ paddingTop: "1em" }} />
            {this.state.viewportWidth > 1024 ? (
              <span>
                <VenatusAdWithPlaceholder
                  placementId={VENATUS_DESKTOP_LEADERBOARD}
                />
              </span>
            ) : (
              <VenatusAdWithPlaceholder
                placementId={VENATUS_MOBILE_INCONTENT}
              />
            )}
            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  8.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[7].number +
                      ".png"
                    }
                    alt={bestCats[7].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[7].number.slice(0, 3) +
                          "/" +
                          bestCats[7].name
                        }
                      >
                        {bestCats[7].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  Supreme overlord and judge of the dead. Condemns evil souls
                  with his infernal scythe. Immune to Toxic &amp; Warp (Area
                  Attack)
                  <p></p>
                  <b>Other forms: </b>Hades the Deathdealer, Almighty Hades
                  <p></p>
                  <b>Pros: </b>His health is off the charts, and he's also on
                  the{" "}
                  <Link to={"/best-cats-for-health"}>Best Cats for Health</Link>{" "}
                  list. Serves as a tank to protect the units behind him, while
                  doing decent damage with very frequent attacks, giving him
                  good DPS.
                  <p></p>
                  <b>Cons: </b>Range of 250 means that even some of the
                  mid-range units may remain unprotected, somewhat defeating his
                  purpose.
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Hades the Punisher"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  7.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[6].number +
                      ".png"
                    }
                    alt={bestCats[6].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[6].number.slice(0, 3) +
                          "/" +
                          bestCats[6].name
                        }
                      >
                        {bestCats[6].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  The highest authority among the old gods of Olympus. Rains
                  down destruction with his Heavenly Lance. Strong vs. Angels.
                  (Area Atk)
                  <p></p>
                  <b>Other forms: </b>The Majestic Zeus, Almighty Zeus
                  <p></p>
                  <b>Pros: </b>Strong generalist with decent stats across the
                  board. No harm using him as a damage dealer, especially in
                  early game.
                  <p></p>
                  <b>Cons: </b>None of his traits really stand out. Despite
                  being Resistant to Angels, he still falls short of what's
                  needed for the tougher Angel enemies like{" "}
                  <Link to={"/enemyinfo/379/Winged%20Pigge"}>Winged Pigge</Link>
                  .
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Thunder God Zeus"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row style={{ padding: "16px 0 0 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  6.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[5].number +
                      ".png"
                    }
                    alt={bestCats[5].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[5].number.slice(0, 3) +
                          "/" +
                          bestCats[5].name
                        }
                      >
                        {bestCats[5].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>Master of storms and seas, one of the 12
                  supreme Olympian gods. Sacred Trident's area attack 100%
                  freezes Zombies/Metal foes.
                  <p></p>
                  <b>Other forms: </b>Valiant Poseidon, Almighty Poseidon
                  <p></p>
                  <b>Pros: </b>Cheap crowd controller that specialises against
                  Zombie and Metal foes with a guaranteed chance of freezing
                  them. Low cooldown also makes him very stackable. Basically,
                  call on him whenever you're facing a challenging Zombie/Metal
                  stage — he'll be the solution at least half the time.
                  <p></p>
                  <b>Cons: </b>Poor range...but with most zombies and metals
                  having even poorer range, this works out just fine.
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Wrathful Poseidon"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            {/* <InPageAdComponent
              style={{ marginTop: "8px" }}
              dataAdClient="ca-pub-1920730948516638"
              dataAdSlot="8579060881"
            /> */}
            <div style={{ paddingTop: "1em" }} />
            {this.state.viewportWidth > 1024 ? (
              <span>
                <VenatusAdWithPlaceholder
                  placementId={VENATUS_DESKTOP_LEADERBOARD}
                />
              </span>
            ) : (
              <VenatusAdWithPlaceholder
                placementId={VENATUS_MOBILE_INCONTENT}
              />
            )}
            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  5.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[4].number +
                      ".png"
                    }
                    alt={bestCats[4].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[4].number.slice(0, 3) +
                          "/" +
                          bestCats[4].name
                        }
                      >
                        {bestCats[4].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>Lord of scholarship and splendor, guardian
                  of the sacred treasures that ward against misfortune. Gains
                  power when damaged (Long Range Area Atk)
                  <p></p>
                  <b>Other forms: </b>Exalted Ganesha, Almighty Ganesha
                  <p></p>
                  <b>Pros: </b>Overall strong health and damage, especially as
                  his attack power doubles at 80% health which is easy to
                  achieve. Also has Long Distance attack.
                  <p></p>
                  <b>Cons: </b>Outclassed in range by{" "}
                  <Link to={"/catinfo/260/Radiant%20Aphrodite"}>
                    Radiant Aphrodite
                  </Link>
                  . Has higher damage than her when damaged, but the range
                  tradeoff is not worth it.
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Splendid Ganesha"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  4.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[3].number +
                      ".png"
                    }
                    alt={bestCats[3].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[3].number.slice(0, 3) +
                          "/" +
                          bestCats[3].name
                        }
                      >
                        {bestCats[3].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>The might and beauty of the Sun
                  personified. Subdues enemies using her sacred mirror. Massive
                  area damage to any enemy with a trait.
                  <p></p>
                  <b>Other forms: </b>Glorious Amaterasu, Almighty Amaterasu
                  <p></p>
                  <b>Pros: </b>Good range — in fact, her range is slightly more
                  than{" "}
                  <Link to={"/catinfo/026/Crazed%20Bahamut%20Cat"}>
                    Crazed Bahamut Cat
                  </Link>{" "}
                  by 5. No blindspot either, so she's able to tackle the enemy
                  frontlines and does better than{" "}
                  <Link to={"/catinfo/494/Gaia%20the%20Creator"}>
                    Gaia the Creator
                  </Link>{" "}
                  against pushers.
                  <b>Cons: </b>Less than half the DPS (or slightly over a
                  quarter of the damage) of{" "}
                  <Link to={"/catinfo/494/Gaia%20the%20Creator"}>
                    Gaia the Creator
                  </Link>
                  .
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Shining Amaterasu"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row style={{ padding: "16px 0 0 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  3.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[2].number +
                      ".png"
                    }
                    alt={bestCats[2].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[2].number.slice(0, 3) +
                          "/" +
                          bestCats[2].name
                        }
                      >
                        {bestCats[2].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>The origin of all Life... and she can
                  choose to undo it all whenever she pleases. Long-range Area
                  attacks deal extreme damage to Traited.
                  <p></p>
                  <b>Other forms: </b>Gaia the Supreme
                  <p></p>
                  <b>Pros: </b>Shines in stages with multiple enemy types. Best
                  generalist attacker against all enemy types except Traitless,
                  with the highest damage and DPS out of all the cats. Her long
                  distance ability is also a great help against enemies with
                  longer range, like{" "}
                  <Link to={"/enemyinfo/340/Cala%20Maria"}>Cala Maria</Link> or{" "}
                  <Link to={"/enemyinfo/149/Le'noir"}>Le'noir</Link>.<p></p>
                  <b>Cons: </b>While her range is slightly shorter than{" "}
                  <Link to={"/catinfo/272/Shining%20Amaterasu"}>
                    Shining Amaterasu
                  </Link>
                  , she still wins in terms of sheer damage. Do protect her
                  well, as her long distance ability also comes with a blindspot
                  that makes her vulnerable to pushers.
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Gaia the Creator"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  2.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[1].number +
                      ".png"
                    }
                    alt={bestCats[1].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[1].number.slice(0, 3) +
                          "/" +
                          bestCats[1].name
                        }
                      >
                        {bestCats[1].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>An almighty titaness who rescued the
                  universe from chaos, keeping order with her Timepiece of
                  Destiny. Freezes any traited enemy with long-range area atks.
                  <p></p>
                  <b>Other forms: </b>Chronos the Infinite, Almighty Chronos
                  <p></p>
                  <b>Pros: </b>One of the best crowd controllers. Her Multi-hit
                  attack traits means that she effectively freezes enemies for
                  3s. True form also grants immunity to Freeze and Warp, which
                  improves her usefulness against enemies like{" "}
                  <Link to={"/enemyinfo/364/Project%20A"}>Project A</Link>. With
                  a healthy range of 450 plus Long Distance attack, she is also
                  a very decent damage dealer.
                  <p></p>
                  <b>Cons: </b>Not so useful against Traitless enemies, and may
                  be vulnerable against strong enemy pushers like{" "}
                  <Link to={"/enemyinfo/175/Ursamajor"}>Ursamajor</Link> and the{" "}
                  <Link to={"/enemyinfo/064/Red%20Cyclone"}>Red Cyclone</Link>.
                  Just make sure to keep her well protected with proper
                  meatshielding.
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Empress Chronos"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            {/* <InPageAdComponent
              dataAdClient="ca-pub-1920730948516638"
              dataAdSlot="8579060881"
            /> */}
            <div style={{ paddingTop: "1em" }} />
            {this.state.viewportWidth > 1024 ? (
              <span>
                <VenatusAdWithPlaceholder
                  placementId={VENATUS_DESKTOP_LEADERBOARD}
                />
              </span>
            ) : (
              <VenatusAdWithPlaceholder
                placementId={VENATUS_MOBILE_INCONTENT}
              />
            )}
            <Row style={{ padding: "0px 0 0px 0" }}>
              <Row style={{ padding: "0px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  1.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[0].number +
                      ".png"
                    }
                    alt={bestCats[0].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[0].number.slice(0, 3) +
                          "/" +
                          bestCats[0].name
                        }
                      >
                        {bestCats[0].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>Deity of beauty, pride, love and… other
                  stuff. Her Golden Bow always strikes true from afar. Deals
                  massive damage to Aliens. (Long Distance)
                  <p></p>
                  <b>Other forms: </b>Megaphrodite, Almighty Aphrodite
                  <p></p>
                  <b>Pros: </b>If you could only get one Uber in the entire
                  game...it'd be a tough fight between her,{" "}
                  <Link to={"/catinfo/138/Kasa%20Jizo"}>Kasa Jizo</Link>, and
                  maybe a couple others. With her amazing range coupled with a
                  Long Distance ability, she devastates even long-ranged enemies
                  like{" "}
                  <Link to={"/enemyinfo/185/Professor%20A."}>Professor A</Link>{" "}
                  while remaining safely protected at the backlines. Her Massive
                  Damage against Aliens doesn't hurt either. Also on the{" "}
                  <Link to={"/best-cats-for-range"}>Best Cats for Range</Link>{" "}
                  list.
                  <p></p>
                  <b>Cons: </b>Her huge blindspot and long time between attacks
                  makes her vulnerable against pushers. But keep her well
                  protected and it shouldn't be an issue.
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Radiant Aphrodite"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            {/* <InPageAdComponent
              dataAdClient="ca-pub-1920730948516638"
              dataAdSlot="8579060881"
            /> */}
            <div style={{ paddingTop: "1em" }} />
            {this.state.viewportWidth > 1024 ? (
              <span>
                <VenatusAdWithPlaceholder
                  placementId={VENATUS_DESKTOP_LEADERBOARD}
                />
              </span>
            ) : (
              <VenatusAdWithPlaceholder
                placementId={VENATUS_MOBILE_INCONTENT}
              />
            )}
            <Row style={{ padding: "6px 0 6px 0", marginTop: "6px" }}>
              <Divider orientation="left" style={{ fontSize: "24px" }}>
                Tier List
              </Divider>
              <TierListTable
                selectedCats={tierList}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row style={{ padding: "6px 0 6px 0" }}>
              <Divider />
              <h3>Compare all 9 cats below</h3>
              <BestCatsTable
                selectedCats={bestCats}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row
              style={{
                padding: "24px 20px 18px 20px",
                backgroundColor: "#ffa50038",
                textAlign: "center",
                margin: "0 0 8px 0",
              }}
            >
              <div style={{ fontSize: "16px" }}>
                Want to compare the stats of any cat in The Battle Cats?
              </div>
              <Divider
                style={{ backgroundColor: "orange", marginTop: "12px" }}
              ></Divider>
              <Button href="/comparecats" size="large">
                Compare more cats
              </Button>
            </Row>
          </Content>
        </Layout>
        {this.state.viewportWidth > 1024 ? (
          <div>
            <VenatusAd
              placementId={VENATUS_RICH_MEDIA_WITH_STICKY_VERTICAL}
              style={{ display: "none" }}
            />
          </div>
        ) : (
          <div>
            <VenatusAd
              placementId={VENATUS_RICH_MEDIA}
              style={{ display: "none" }}
            />
          </div>
        )}
        {/* <HorizontalAdPopup
          dataAdClient="ca-pub-1920730948516638"
          dataAdSlot="3694383950"
        ></HorizontalAdPopup> */}
        {/* <div id="waldo-tag-14678"></div> */}
      </div>
    );
  }
}

export default Almighties;

Almighties.propTypes = {
  applyViewportChange: PropTypes.number,
};

Almighties.defaultProps = {
  applyViewportChange: 250,
};



// WEBPACK FOOTER //
// ./src/components/content/tierlist/Almighties.js